import { Professional } from '@abiglobalhealth/go-types'
import { useTranslation } from 'react-i18next'
import Markdown from 'react-markdown'

import { getProfessionalKey } from '@/locale/utils'

interface DoctorAnswerCardProps {
  answer: string
  professional: Professional
}

export const DoctorAnswerCard = ({ answer, professional }: DoctorAnswerCardProps) => {
  const { t } = useTranslation()

  return (
    <section className="drop-shadow-chat-bubble flex w-full flex-col gap-4 rounded-2xl bg-white px-4 pt-4 pb-6" data-testid="doctor-answer-card">
      <div className="flex items-center gap-2">
        {professional.profileImg && <img alt="" className="h-10 w-10 rounded-full object-cover" src={professional.profileImg} />}
        <p className="font-semibold">
          {t(getProfessionalKey(professional), {
            name: professional.name
          })}
        </p>
      </div>
      <div className="markdown replay-mask list-decimal wrap-break-word">
        <Markdown>{answer}</Markdown>
      </div>
    </section>
  )
}
